import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d28a943"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Tags", -1))
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Eigenschaften", -1))
const _hoisted_4 = { key: 2 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Sortierung", -1))
const _hoisted_6 = { class: "radios" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_input_field = _resolveComponent("md-input-field")!
  const _component_md_badge = _resolveComponent("md-badge")!
  const _component_md_checkbox = _resolveComponent("md-checkbox")!
  const _component_empty_hint = _resolveComponent("empty-hint")!
  const _component_md_radio = _resolveComponent("md-radio")!
  const _component_md_button = _resolveComponent("md-button")!
  const _component_md_modal = _resolveComponent("md-modal")!

  return (_openBlock(), _createBlock(_component_md_modal, {
    ref: "modal",
    title: "Ansicht erstellen",
    icon: "filter_alt"
  }, {
    default: _withCtx(() => [
      _createTextVNode(" Erstelle eine neue Ansicht, um Konversationen leichter zu finden. Du kannst ein oder mehrere Tags auswählen, die in der Ansicht angezeigt werden sollen. ")
    ]),
    body: _withCtx(() => [
      _createVNode(_component_md_input_field, {
        variant: "outlined",
        modelValue: _ctx.name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event)),
        label: "Name",
        ref: "nameInput",
        validator: _ctx.nameValidator
      }, null, 8, ["modelValue", "validator"]),
      _hoisted_1,
      (_ctx.tags)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tags, (tag) => {
              return (_openBlock(), _createElementBlock("li", {
                key: tag.id
              }, [
                _createVNode(_component_md_checkbox, {
                  value: tag.id,
                  modelValue: _ctx.selectedTags,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedTags) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_md_badge, {
                      color: _ctx.getColor(tag.color)
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(tag.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["color"])
                  ]),
                  _: 2
                }, 1032, ["value", "modelValue"])
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createBlock(_component_empty_hint, {
            key: 1,
            hint: "",
            variant: "inline",
            title: "Keine Tags erstellt"
          })),
      _hoisted_3,
      (_ctx.fields)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fields, (field) => {
              return (_openBlock(), _createElementBlock("li", {
                key: field.value
              }, [
                _createVNode(_component_md_checkbox, {
                  value: field.value,
                  modelValue: _ctx.selectedFields,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedFields) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_md_badge, {
                      color: _ctx.getColor(field.color)
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(field.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["color"])
                  ]),
                  _: 2
                }, 1032, ["value", "modelValue"])
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sorts, (sort) => {
          return (_openBlock(), _createBlock(_component_md_radio, {
            key: sort.id,
            modelValue: _ctx.selectedSort,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedSort) = $event)),
            value: sort.id
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(sort.name), 1)
            ]),
            _: 2
          }, 1032, ["modelValue", "value"]))
        }), 128))
      ])
    ]),
    actions: _withCtx(() => [
      _createVNode(_component_md_button, {
        variant: "text",
        grey: "",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.close()))
      }, {
        default: _withCtx(() => [
          _createTextVNode("Abbrechen")
        ]),
        _: 1
      }),
      _createVNode(_component_md_button, {
        variant: "filled",
        onClick: _ctx.createView
      }, {
        default: _withCtx(() => [
          _createTextVNode("Ansicht erstellen")
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _: 1
  }, 512))
}